import React from "react";

const ImpressionIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.63887 14.75C8.16479 15.213 8.62776 15.4444 9.02776 15.4444C10.4166 15.4444 11.1111 14.75 11.1111 13.3611C11.1111 12.4352 11.5741 11.5093 12.5 10.5833C13.3798 9.70347 13.8889 8.45347 13.8889 7.11111C13.8889 5.82186 13.3767 4.58542 12.4651 3.67379C11.5534 2.76215 10.317 2.25 9.02776 2.25C7.73851 2.25 6.50207 2.76215 5.59043 3.67379C4.6788 4.58542 4.16665 5.82186 4.16665 7.11111M11.8055 7.11111C11.8055 6.3744 11.5129 5.66786 10.9919 5.14693C10.471 4.62599 9.76447 4.33333 9.02776 4.33333C8.29104 4.33333 7.58451 4.62599 7.06357 5.14693C6.54264 5.66786 6.24998 6.3744 6.24998 7.11111M2.08331 14.0556L5.55554 9.88889L6.24998 12.6667L9.7222 8.5"
        stroke="#BF740A"
        strokeWidth="1.38889"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ImpressionIcon;
